var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"tag",class:{'is-danger': !_vm.isDefaultDepositGroup}},[_vm._v(_vm._s(_vm.$t(`deposit_ratio.${_vm.effectiveDeposit}`)))])
}
var staticRenderFns = []

export { render, staticRenderFns }